














































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '@/store';
import { IAgreement, IProposal, IContractor, IUser } from '@/models';
import { BaseDetail } from '../Base/BaseDetail';
import { getUserFullName } from '@/helpers/functions';
const namespace = 'agreement';
const ns = { namespace };

@Component({
  methods: {
    getUserFullName,
  },
})
export default class AgreementDetail extends BaseDetail<IAgreement> {
  namespace = namespace;
  input = null;
  @State('entities', ns) entities: Record<string, IAgreement>;
  @State('entities', { namespace: 'proposal' }) proposals: Record<
    string,
    IProposal
  >;
  @State('entities', { namespace: 'contractor' }) contractors: Record<
    string,
    IContractor
  >;
  @State('entities', { namespace: 'employee' }) employees: Record<
    string,
    IContractor
  >;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('pushMessage', ns) pushMessage: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.setValue(this.entityPatch, 'creator_id', this.user.id);
    this.loadEntity();
  }
  get messages() {
    return this.entity?.chat?.messages?.slice().reverse() || [];
  }
  comment() {
    if (this.input && this.input !== null) {
      client
        .post(`/message`, {
          content: this.input,
          chat_id: this.entity?.chat?.id,
          creator_id: this.user.id,
        })
        .then(({ data }) => this.pushMessage({ id: this.entity.id, data }));

      this.input = null;
    }
  }
}
